import { render } from "./Feed.vue?vue&type=template&id=7b87d3d3&ts=true"
import script from "./Feed.vue?vue&type=script&lang=ts"
export * from "./Feed.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Episcenter\\smartCity\\smartcity\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__